import React from 'react';
import { connect } from 'react-redux';
import DashboardPowerBI, { DashboardTypes } from '../components/DashboardsPB/DashboardPowerBI';

const mapStateToProps = (state: any) => ({
    // Add any state props if needed
});

const mapDispatchToProps = {
    // Add any dispatch props if needed
};

const DashboardPBOperativeService = connect(
    mapStateToProps,
    mapDispatchToProps
)(() => <DashboardPowerBI dashboardType={DashboardTypes.OPERATIVO} />);

const DashboardPBManagementControlService = connect(
    mapStateToProps,
    mapDispatchToProps
)(() => <DashboardPowerBI dashboardType={DashboardTypes.GESTION} />);

const DashboardPBMobilityService = connect(
    mapStateToProps,
    mapDispatchToProps
)(() => <DashboardPowerBI dashboardType={DashboardTypes.MOBILITY} />);


export {DashboardPBOperativeService, DashboardPBManagementControlService, DashboardPBMobilityService}; 